module.exports = __webpack_public_path__ + "img/14.4ac31708.png";